import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const ProductLevelToSuitePFHeaderTranslationKeyMap = {
  [FREE]: 'merchCards.priorityFeatures.suite.FREE.header',
  [STARTER]: 'merchCards.priorityFeatures.suite.STARTER.header',
  [PROFESSIONAL]: 'merchCards.priorityFeatures.suite.PROFESSIONAL.header',
  [ENTERPRISE]: 'merchCards.priorityFeatures.suite.ENTERPRISE.header'
};
export const ProductLevelAndProductLineToSuitePFTranslationKeyMap = {
  [FREE]: {
    [MARKETING]: {
      title: 'merchCards.priorityFeatures.suite.FREE.MARKETING.title'
    },
    [SALES]: {
      title: 'merchCards.priorityFeatures.suite.FREE.SALES.title'
    },
    [SERVICE]: {
      title: 'merchCards.priorityFeatures.suite.FREE.SERVICE.title'
    },
    [CMS]: {
      title: 'merchCards.priorityFeatures.suite.FREE.CMS.title'
    },
    [OPERATIONS]: {
      title: 'merchCards.priorityFeatures.suite.FREE.OPERATIONS.title'
    },
    [COMMERCE]: {
      title: 'merchCards.priorityFeatures.suite.FREE.COMMERCE.title'
    }
  },
  [STARTER]: {
    [MARKETING]: {
      title: 'merchCards.priorityFeatures.suite.STARTER.MARKETING.title',
      subtext: 'merchCards.priorityFeatures.suite.STARTER.MARKETING.subtext_jsx'
    },
    [SALES]: {
      title: 'merchCards.priorityFeatures.suite.STARTER.SALES.title',
      subtext: 'merchCards.priorityFeatures.suite.STARTER.SALES.subtext_jsx'
    },
    [SERVICE]: {
      title: 'merchCards.priorityFeatures.suite.STARTER.SERVICE.title',
      subtext: 'merchCards.priorityFeatures.suite.STARTER.SERVICE.subtext_jsx'
    },
    [CMS]: {
      title: 'merchCards.priorityFeatures.suite.STARTER.CMS.title'
    },
    [OPERATIONS]: {
      title: 'merchCards.priorityFeatures.suite.STARTER.OPERATIONS.title'
    },
    [COMMERCE]: {
      title: 'merchCards.priorityFeatures.suite.STARTER.COMMERCE.title'
    }
  },
  [PROFESSIONAL]: {
    [MARKETING]: {
      title: 'merchCards.priorityFeatures.suite.PROFESSIONAL.MARKETING.title',
      subtext: 'merchCards.priorityFeatures.suite.PROFESSIONAL.MARKETING.subtext_jsx'
    },
    [SALES]: {
      title: 'merchCards.priorityFeatures.suite.PROFESSIONAL.SALES.title',
      subtext: 'merchCards.priorityFeatures.suite.PROFESSIONAL.SALES.subtext_jsx'
    },
    [SERVICE]: {
      title: 'merchCards.priorityFeatures.suite.PROFESSIONAL.SERVICE.title',
      subtext: 'merchCards.priorityFeatures.suite.PROFESSIONAL.SERVICE.subtext_jsx'
    },
    [CMS]: {
      title: 'merchCards.priorityFeatures.suite.PROFESSIONAL.CMS.title'
    },
    [OPERATIONS]: {
      title: 'merchCards.priorityFeatures.suite.PROFESSIONAL.OPERATIONS.title'
    },
    [COMMERCE]: {
      title: 'merchCards.priorityFeatures.suite.PROFESSIONAL.COMMERCE.title'
    }
  },
  [ENTERPRISE]: {
    [MARKETING]: {
      title: 'merchCards.priorityFeatures.suite.ENTERPRISE.MARKETING.title',
      subtext: 'merchCards.priorityFeatures.suite.ENTERPRISE.MARKETING.subtext_jsx'
    },
    [SALES]: {
      title: 'merchCards.priorityFeatures.suite.ENTERPRISE.SALES.title',
      subtext: 'merchCards.priorityFeatures.suite.ENTERPRISE.SALES.subtext_jsx'
    },
    [SERVICE]: {
      title: 'merchCards.priorityFeatures.suite.ENTERPRISE.SERVICE.title',
      subtext: 'merchCards.priorityFeatures.suite.ENTERPRISE.SERVICE.subtext_jsx'
    },
    [CMS]: {
      title: 'merchCards.priorityFeatures.suite.ENTERPRISE.CMS.title'
    },
    [OPERATIONS]: {
      title: 'merchCards.priorityFeatures.suite.ENTERPRISE.OPERATIONS.title'
    },
    [COMMERCE]: {
      title: 'merchCards.priorityFeatures.suite.ENTERPRISE.COMMERCE.title'
    }
  }
};